const $ = jQuery.noConflict();
import 'slick-carousel';

const sliders = [];
const blocks = document.querySelectorAll('.block-hero-featured-insights');

const initSliders = () => {
	if (blocks.length) {
		blocks.forEach((block) => {
			const sliderContainer = block.querySelector(
				'.block-hero-featured-insights__slider'
			);
			// Add loaded class for initial transition
			$(sliderContainer).on('init', () => {
				$(sliderContainer).addClass('loaded');
			});
			// Remove loaded class to allow for onChange transitions
			$(sliderContainer).on('afterChange', () => {
				$(
					'.block-hero-featured-insights__slide.initial-transition',
					sliderContainer
				).removeClass('initial-transition');
			});
			const slickSlider = $(sliderContainer).slick({
				arrows: false,
				dots: true,
				fade: true,
				autoplay: true,
				autoplaySpeed: 6000,
			});
			if (sliderContainer) {
				sliders.push({
					slider: slickSlider,
				});
			}
		});
	}
};

const controller = {
	init() {
		initSliders();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
